import omit from 'lodash/omit';

import { LinkData } from 'src/containers/ProjectDiagram/types/model';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 *  Migration to flag projects for redraw due to smaller resource node size and removes points from linkData
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v23 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v23Projects(prevState.projects);
  }

  return nextState;
};

const v23Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          linkDataArray: project.diagram.model.linkDataArray.map(
            (linkData) => omit(linkData, 'points') as LinkData
          ),
          modelData: {
            ...project.diagram.model.modelData,
            flaggedForRedraw: true,
          },
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
